'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _form = require('./form');

var _form2 = _interopRequireDefault(_form);

var _form_cell = require('./form_cell');

var _form_cell2 = _interopRequireDefault(_form_cell);

var _textarea = require('./textarea');

var _textarea2 = _interopRequireDefault(_textarea);

var _input = require('./input');

var _input2 = _interopRequireDefault(_input);

var _switch = require('./switch');

var _switch2 = _interopRequireDefault(_switch);

var _radio = require('./radio');

var _radio2 = _interopRequireDefault(_radio);

var _checkbox = require('./checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _select = require('./select');

var _select2 = _interopRequireDefault(_select);

var _uploader = require('./uploader');

var _uploader2 = _interopRequireDefault(_uploader);

var _vcode = require('./vcode');

var _vcode2 = _interopRequireDefault(_vcode);

var _agreement = require('./agreement');

var _agreement2 = _interopRequireDefault(_agreement);

var _preview = require('./preview');

var _preview2 = _interopRequireDefault(_preview);

var _preview_header = require('./preview_header');

var _preview_header2 = _interopRequireDefault(_preview_header);

var _preview_body = require('./preview_body');

var _preview_body2 = _interopRequireDefault(_preview_body);

var _preview_footer = require('./preview_footer');

var _preview_footer2 = _interopRequireDefault(_preview_footer);

var _preview_item = require('./preview_item');

var _preview_item2 = _interopRequireDefault(_preview_item);

var _slider = require('./slider');

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    Form: _form2.default,
    FormCell: _form_cell2.default,
    TextArea: _textarea2.default,
    Input: _input2.default,
    Switch: _switch2.default,
    Radio: _radio2.default,
    Checkbox: _checkbox2.default,
    Select: _select2.default,
    Uploader: _uploader2.default,
    VCode: _vcode2.default,
    Agreement: _agreement2.default,
    Preview: _preview2.default,
    PreviewHeader: _preview_header2.default,
    PreviewBody: _preview_body2.default,
    PreviewFooter: _preview_footer2.default,
    PreviewItem: _preview_item2.default,
    Slider: _slider2.default
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/form/index.js
// module id = 1751
// module chunks = 7